export const redirectByPost = (url: string, params: Object, inNewTab: boolean) =>{
  params = params || {};
  inNewTab = inNewTab === undefined ? true : inNewTab;

  const form = document.createElement("form");
  form.id = "redirectByPostForm";
  form.name = "redirectByPostForm";
  form.action = url;
  form.method = "POST";
  form.enctype = "multipart/form-data";

  if (inNewTab) {
    form.target = "_blank";
  }

  Object.keys(params).forEach(function (key) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = key;
    input.value = params[key];
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);

  return false;
}


// WEBPACK FOOTER //
// ./src/utils/RedirectByPost.ts